import { useRef, useEffect } from "react";

import { isDrawingFormCategory, TicketingFormCategory } from "@simplyk/common";

import { AmplitudeEvents } from "@/common/constants/amplitude";
import { useAmplitude } from "@/common/hooks/amplitude/useAmplitude";
import { useIsOnboarding } from "@/common/hooks/useIsOnboarding";
import { TicketingOutput, DonationFormWithUserOrOrgAccessOutput } from "@/common/types/trpc";

/**
 * Logs the form edition start event exactly once,
 * if the form is not in "draft" status.
 */
export function useLogFormEditionStarted(
  formObject: TicketingOutput | DonationFormWithUserOrOrgAccessOutput,
  formType: "ticketing" | "donation-form"
) {
  const { logAmplitudeEvent } = useAmplitude();
  const firstRender = useRef(true);
  const { isOnboarding } = useIsOnboarding();

  useEffect(() => {
    if (!formObject || !firstRender.current) {
      return;
    }
    if (formObject.status !== "draft") {
      logAmplitudeEvent(AmplitudeEvents.FormEditionStarted, {
        is_onboarding: isOnboarding,
        form_type: formType,
        is_liveform: true,
        ...(formType === "ticketing" &&
          "formCategory" in formObject && {
            is_sweepstakes: formObject.formCategory === TicketingFormCategory.Sweepstakes,
          }),
        ...(formType === "ticketing" &&
          "formCategory" in formObject &&
          isDrawingFormCategory(formObject.formCategory) && {
            lottery_type: formObject.formCategory === TicketingFormCategory.Sweepstakes ? "sweepstakes" : "raffle",
          }),
      });
      firstRender.current = false;
    }
  }, [formObject, formType, isOnboarding, logAmplitudeEvent]);
}
